import { regEventDb } from 'nike-re-framejs';
import { defaultMiddlewares } from './common/util';
import * as betslip from './betslip/index';
import * as account from './account/index';
import * as server from './server/index';
import { initFavorites } from './favorites/handlers';
import { initNotificationSettings } from './notifications/web-notification-browser';
import { initUserSetting } from './menu/handlers';
import { initInformationDutyOverlay } from './ui/informationduty';
import { initStories } from './home/handlers-stories';
import { initTheme } from 'nike-ui/src/common/theme';
import { migrateTicketsLs } from '@/mytickets/saved/utils';
import { submittedTicketTracker } from '@/trackUserTicket/handlers';
import { initOncePerLogin } from '@/oncePerLogin';
import { initHideDeposit } from 'nike-ui/src/components/settings/h&s';
import { initLuckyWheel } from 'nike-ui/src/components/lucky-wheel/h&s';

regEventDb('application/init/sync', defaultMiddlewares, (db, [loggedIn]) =>
    db
        .set('loggedIn', loggedIn)
        .update(betslip.configureBetslip)
        .update(account.initializeAccountSnapshot)
        .update(initUserSetting)
        .update(initFavorites)
        .update(initNotificationSettings)
        .update(initInformationDutyOverlay)
        .update(initStories)
        .update(db => initTheme(db.getIn(['account', 'userData', 'darkTheme']))(db))
        .update(initOncePerLogin)
        .update(migrateTicketsLs)
        .update(submittedTicketTracker)
        .update(initHideDeposit)
        .update(initLuckyWheel)
);

regEventDb('application/init/after', defaultMiddlewares, db =>
    db.update(server.scheduleVersionChecking).update(account.scheduleAccountUpdating)
);
